import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Helmet } from "react-helmet"

function MetaHead({ description, title, titleSEO, seoImage="", tags, children, priority='0.5', isFollow=true, slugUrl}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescriptionVal = description || site.siteMetadata.description
  const defaultTitle = titleSEO ? titleSEO : site.siteMetadata?.title

  const keywords = Array.isArray(tags) ? tags.join(", ") : '';

  return (
    <>
      <Helmet>
        
        <title>{defaultTitle ? `${defaultTitle}` : title}</title>
        <meta name="description" content={metaDescriptionVal} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={metaDescriptionVal} />
        <meta property="og:image" content={seoImage}/>
        <meta name="keywords" content={keywords}></meta>
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:creator" content={site.siteMetadata?.author || ``} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={metaDescriptionVal} />
        <meta name="robots" content={isFollow ? "index,follow":'noindex,nofollow'} />
        <meta name="p:domain_verify" content="82b50ccc07565998178355b75bd6a5d4"/>
        
        <meta charset="UTF-8"></meta>
        <link rel="canonical" href={slugUrl} />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="true"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Karla:wght@400;700&family=Open+Sans:wght@400;700;800&display=swap"
          rel="stylesheet"
        />
        <script src="https://www.google.com/recaptcha/api.js" async defer></script>
        {/* Google Tag Manager */}
        <script>
          {`
            (function(w,d,s,l,i){
              w[l]=w[l]||[];
              w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
              var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
              j.async=true;
              j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
              f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-5WXHFHS4');
          `}
        </script>
        {/* End Google Tag Manager */}
        {/* Add your Google Analytics tracking code here */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=UA-283482849-1"></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag() {
              dataLayer.push(arguments);
            }
            gtag('js', new Date());
            gtag('config', 'UA-78737127-1');
          `}
        </script>
        {/* Pinterest Tag */}
        {/* <meta name="p:domain_verify" content="82b50ccc07565998178355b75bd6a5d4"/> */}
        
        <script type="text/javascript">
          {`
            !function(e){if(!window.pintrk){window.pintrk = function () {
            window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var
              n=window.pintrk;n.queue=[],n.version="3.0";var
              t=document.createElement("script");t.async=!0,t.src=e;var
              r=document.getElementsByTagName("script")[0];
              r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
            pintrk('load', '2613585334298', {em: '<user_email_address>'});
            pintrk('page');
          `}
        </script>
        <script src="https://embed.acuityscheduling.com/js/embed.js" type="text/javascript"></script>
        <img
            height="1"
            width="1"
            style={{ display: 'none' }}
            alt=""
            src="https://ct.pinterest.com/v3/?event=init&tid=2613585334298&pd%5Bem%5D=HASHED_EMAIL_ADDRESS&noscript=1"
        />
        {/* end Pinterest Tag */}
      </Helmet>
      {children}
    </>
  )
}

export default MetaHead
